import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useGoBack } from '../../hooks/useGoBack';
import { Progress } from '@/components/ui/progress';
import { useAuth } from '@/auth';
import SidebarLayout from './SidebarLayout';

const FOOTER_MESSAGE = `
La presente obra de desarrollo de software se encuentra protegida según lo establecido por la Ley 11723 (Régimen legal de la Propiedad Intelectual) y sus modificatorias.

Artículo 270 apartado 1 del C.P: "Será castigado con la pena de prisión de seis meses a cuatro años y multa de doce a veinticuatro meses el que, con ánimo de obtener un beneficio económico directo o indirecto y en perjuicio de tercero, reproduzca, plagie, distribuya, comunique públicamente o de cualquier otro modo explote económicamente, en todo o en parte, una obra o prestación literaria, artística o científica, o su transformación, interpretación o ejecución artística fijada en cualquier tipo de soporte o comunicada a través de cualquier medio, sin la autorización de los titulares de los correspondientes derechos de propiedad intelectual o de sus cesionarios".
`;

interface AppLayoutProps {
  title?: string;
  prevAction?: () => void;
  prevButtonVisible?: boolean;
  children: React.ReactNode;
  prevPath?: string;
  fallbackPath?: string;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  title = "",
  prevAction,
  prevButtonVisible = true,
  prevPath,
  fallbackPath = '/',
  children
}) => {
  const { loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { goBack } = useGoBack({ checkHistory: true, fallbackPath });

  const handlePrevClick = () => {
    if (prevPath) {
      navigate(prevPath, { replace: true, state: location.state });
      return;
    }

    if (prevAction) {
      prevAction();
    } else {
      goBack();
    }
  };

  return (
    <SidebarLayout
      title={title}
      prevButtonVisible={prevButtonVisible}
      onPrevClick={handlePrevClick}
    >
      <div className="min-h-[calc(100dvh-4rem)] bg-gray-100 flex flex-col">
        <div className="flex-1 p-2 sm:p-4">
          {loading
            ? <Progress value={undefined} className="h-1" />
            : children
          }
        </div>

        <footer className="bg-white py-4 px-4 md:px-8 max-w-full mx-auto w-full">
          <p className="hidden md:block text-sm">
            {FOOTER_MESSAGE}
          </p>
          <details className="md:hidden text-xs text-gray-600">
            <summary className="cursor-pointer py-1">Aviso legal (Ley 11723)</summary>
            <p className="mt-1">{FOOTER_MESSAGE}</p>
          </details>
          <p className="text-xs md:text-sm">
            Escribanía Passerini - Sistema desarrollado por GolpeDigital.com
          </p>
        </footer>
      </div>
    </SidebarLayout>
  );
};

export default AppLayout;
